import { render, staticRenderFns } from "./CommissionDisplay.vue?vue&type=template&id=29bdbdb6"
import script from "./CommissionDisplay.vue?vue&type=script&lang=js"
export * from "./CommissionDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports